module.exports = __webpack_public_path__ + "media/src/img/source_code-b12cbc14ce964c75386d63df74c76f4cf7d8936cb1c688d9e122b5df06d55cba.svg";